module.exports = __webpack_public_path__ + "static/img/popular-03.ccae4db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popular-03.jpg
// module id = mokG
// module chunks = 1